<template>
  <div class="multiselector-fauna">
    <!-- <BotonQuitarTodos /> -->
    <div class="leyenda-item-fauna">
      <input
        type="checkbox"
        class="checkbox"
        id="leyenda-aves"
        v-model="aves_checked"
      />
      <label for="leyenda-aves">
        <img :src="publicPath+'/pictogramas/aves.svg'" alt="" />
        Aves
      </label>
      <BotonMasInfo v-width-control="'45%'" @click="mostrarFichaAves" />
    </div>

    <div class="leyenda-item-fauna">
      <input
        type="checkbox"
        class="checkbox"
        id="leyenda-peces"
        v-model="peces_checked"
      />
      <label for="leyenda-peces">
        <img :src="publicPath+'/pictogramas/peces.svg'" alt="" />
        Peces
      </label>
      <!-- <BotonMasInfo disabled /> -->
    </div>

    <div class="leyenda-item-fauna">
      <input
        type="checkbox"
        class="checkbox"
        id="leyenda-reptiles"
        v-model="reptiles_checked"
      />
      <label for="leyenda-reptiles">
        <img :src="publicPath+'/pictogramas/reptiles.svg'" alt="" />
        Reptiles
      </label>
      <!-- <BotonMasInfo disabled /> -->
    </div>

    <div class="leyenda-item-fauna">
      <input
        type="checkbox"
        class="checkbox"
        id="leyenda-anfibios"
        v-model="anfibios_checked"
      />
      <label for="leyenda-anfibios">
        <img :src="publicPath+'/pictogramas/anfibios.svg'" alt="" />
        Anfibios
      </label>
      <!-- <BotonMasInfo disabled /> -->
    </div>

    <div class="leyenda-item-fauna">
      <input
        type="checkbox"
        class="checkbox"
        id="leyenda-mamiferos"
        v-model="mamiferos_checked"
      />
      <label for="leyenda-mamiferos">
        <img :src="publicPath+'/pictogramas/mamiferos.svg'" alt="" />
        Mamiferos
      </label>
      <!-- <BotonMasInfo disabled /> -->
    </div>
  </div>
</template>

<script>
import BotonMasInfo from "./BotonMasInfo.vue";
// import BotonQuitarTodos from "./BotonQuitarTodos.vue";
import { scrollTo } from "@/components/_utils.js";

export default {
  components: {
    BotonMasInfo,
    // BotonQuitarTodos,
  },
  data(){
    return {
      publicPath: process.env.VUE_APP_BASE_ROUTE === '/' ? '' : process.env.VUE_APP_BASE_ROUTE,
    }
  },
  methods: {
    mostrarFichaAves() {
      this.$store.commit("mapa/setFichaActiva", "fauna_aves");
      scrollTo(document.querySelector("[data-section='fichas']"),-102);
    },
  },
  computed: {
    aves_checked: {
      get() {
        return this.$store.getters["mapa/esteTipoDeFaunaEstaActivo"]("aves");
      },
      set(check) {
        this.$store.commit("mapa/setFaunaTipos", {
          tipo: "aves",
          visible: check,
        });
      },
    },
    peces_checked: {
      get() {
        return this.$store.getters["mapa/esteTipoDeFaunaEstaActivo"]("peces");
      },
      set(check) {
        this.$store.commit("mapa/setFaunaTipos", {
          tipo: "peces",
          visible: check,
        });
      },
    },
    reptiles_checked: {
      get() {
        return this.$store.getters["mapa/esteTipoDeFaunaEstaActivo"](
          "reptiles"
        );
      },
      set(check) {
        this.$store.commit("mapa/setFaunaTipos", {
          tipo: "reptiles",
          visible: check,
        });
      },
    },
    anfibios_checked: {
      get() {
        return this.$store.getters["mapa/esteTipoDeFaunaEstaActivo"](
          "anfibios"
        );
      },
      set(check) {
        this.$store.commit("mapa/setFaunaTipos", {
          tipo: "anfibios",
          visible: check,
        });
      },
    },
    mamiferos_checked: {
      get() {
        return this.$store.getters["mapa/esteTipoDeFaunaEstaActivo"](
          "mamíferos"
        );
      },
      set(check) {
        this.$store.commit("mapa/setFaunaTipos", {
          tipo: "mamiferos",
          visible: check,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.multiselector-fauna {
  width: calc(100%) !important;
  padding-top: 16px;

  .leyenda-item-fauna {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;  

    label {
      flex-grow: 1;
      font-size: 13px;
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
        margin-right: 0.5em;
      }
    }

    input[type="checkbox"].checkbox {
      background-color: var(--control-bg-color);
      font-size: inherit;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      width: 26px;
      height: 26px;
      border-radius: 5px;
      border: 1px solid var(--control-color);
      cursor: pointer;
      margin-right: 0.5em;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 1.5em 1.5em;
      flex-grow: 0;

      //quitando algunas cossas que pone la base web
      margin-bottom: 6px;
      margin-top: 0;
      margin-left: 0;

      &:checked {
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 512 512"><path d="m186 340l-90-91-32 31 122 122 262-261-32-31z"></path></svg>');
      }
    }
  }
}
</style>